module.exports = __webpack_public_path__ + "static/media/reglamento_1.5f6845ed.png";